<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import store from '@/vuex'

store.subscribe((mutation, state) => {
  localStorage.setItem('truckme-vuex', JSON.stringify(state))
})

const loadJSAsync = (url) => {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    document.body.appendChild(script)
}

export default {
  name: 'App',
  store,
  mounted() {
    // var script = document.createElement('script');
    // script.text = "window.fwSettings={ 'widget_id':66000003020 };!function(){if(\"function\"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()"
    // document.body.appendChild(script)

    // loadJSAsync('https://widget.freshworks.com/widgets/66000003020.js')
  },
}
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/App.vue